import React from "react";
import FranchiseApplicationForm from "../components/FranchiseApplicationForm";

function FranchiseApply() {
  return (
    <div className="container py-4 py-lg-5">
      <FranchiseApplicationForm mode="public" />
    </div>
  );
}

export default FranchiseApply;
